import React from 'react';
import { Info } from 'lucide-react';
interface StepGuideProps {
  text: string;
}
export const StepGuide: React.FC<StepGuideProps> = ({
  text
}) => {
  return <div className="bg-[#CDA735]/20 border-b border-[#CDA735]/30 p-4 flex items-start" data-id="element-793">
      <Info className="h-5 w-5 text-[#CDA735] mt-0.5 flex-shrink-0" data-id="element-794" />
      <p className="ml-3 text-white/90 text-sm" data-id="element-795">{text}</p>
    </div>;
};